import React, { useState, useEffect } from 'react'
import { CSSTransition } from 'react-transition-group'
import BreakHTMLFooter from 'steps/BreakHTMLFooter'
import queryString from 'query-string'
import getStepName from 'util/stepTypeStrings'
import './StartSlideWrapper.scss'

// handleStartSlideClick allows parent components to prevent this from starting
const StartSlideWrapper = ({
  step,
  children,
  handleStartSlideClick = function () {},
  breakFooterHTML,
  startScreenDisabled,
  isIntersecting,
}) => {
  let showStartScreen = step.hasStartScreen && !startScreenDisabled
  //   console.log(`rendering start slide wrapper ${step.id}`)
  //complete step never has start screen
  if (step.type === 'COMPLETE') {
    showStartScreen = false
  }
  const [startScreenDisabledByQuery, setStartScreenDisabledByQuery] =
    useState(false)
  useEffect(() => {
    checkQuery()
  }, [])
  const checkQuery = () => {
    try {
      if (window !== undefined) {
        let query = queryString.parse(window.location.search)
        if (query) {
          if (query.galleryitem || query.stepId) {
            setStartScreenDisabledByQuery(true)
          }
        }
      }
    } catch (error) {
      console.log(`error`, error)
    }
  }

  const hasStartScreen = showStartScreen === true && !startScreenDisabledByQuery
  const [startSlideActive, setStartSlideActive] = useState(true)

  const startSlideClickHandler = async () => {
    let result = await handleStartSlideClick()

    // non-step3 steps don't return anything
    // step3 returns false if something prevents us from starting
    if (result === undefined || result === true) {
      setStartSlideActive(false)
    }
  }
  const animationDuration = 600

  const StartSlide = ({
    headline,
    para,
    footer,
    bgImageExists,
    backgroundImageId,
    backgroundColor,
    onStartClicked,
    breakFooterHTML,
    isIntersecting,
  }) => {
    let style = {}

    if (backgroundColor) {
      style.backgroundColor = backgroundColor
    }

    if (backgroundImageId) {
      style.backgroundImage = `url(${process.env.SITE_ASSET_URL}/${backgroundImageId})`
    }

    const stepName = getStepName(step.type)
    return (
      <div
        className={`start-slide ${
          breakFooterHTML ? `has-html-footer` : `no-html-footer`
        }`}
        style={style}
      >
        <div className="container start-slide-container">
          <div className={`start-slide-inner-content-wrapper`}>
            <div
              className={`start-slide__content${
                !bgImageExists ? ' no-background' : ''
              }`}
            >
              <h2 dangerouslySetInnerHTML={{ __html: headline }}></h2>
              <p
                className="start-body"
                dangerouslySetInnerHTML={{ __html: para }}
              ></p>
              <div>
                {/* added ID is for hacky css overrides in beaker. */}
                <button
                  tabIndex={isIntersecting ? 0 : -1}
                  role="button"
                  id="start-slide-button"
                  className="btn start-button"
                  onClick={onStartClicked}
                >
                  Start {stepName}
                </button>
              </div>
              <p
                className="start-footer"
                dangerouslySetInnerHTML={{ __html: footer }}
              ></p>
            </div>
          </div>
        </div>
        {breakFooterHTML && (
          <div className="sponsored-flow-panel--footer sponsored-flow-panel-3--footer">
            <BreakHTMLFooter content={breakFooterHTML} />
          </div>
        )}
      </div>
    )
  }
  return (
    <>
      {hasStartScreen ? (
        <div className="start-wrapper">
          <style
            dangerouslySetInnerHTML={{
              __html: `
            .transition-slide {
              transition: transform ${animationDuration}ms ease-in-out;
            }
        `,
            }}
          />
          <CSSTransition
            className={`transition-slide transition-start-slide ${
              startSlideActive ? 'is--active' : 'is--inactive'
            }`}
            key={`start-slide`}
            in={startSlideActive === true}
            exit={startSlideActive === false}
            timeout={animationDuration}
            unmountOnExit={false}
            /* appear={startSlideActive === true}*/
          >
            <div className="start-wrapper-item start-wrapper-start">
              <StartSlide
                isIntersecting={isIntersecting}
                headline={step.startHeader || step.headline}
                para={step.startBody}
                footer={step.startFooter}
                backgroundImageId={step.startBackgroundImageId}
                backgroundColor={step.startBackgroundColor}
                onStartClicked={startSlideClickHandler}
                breakFooterHTML={breakFooterHTML}
              />
            </div>
          </CSSTransition>

          <CSSTransition
            className={`transition-slide transition-content-slide ${
              startSlideActive ? 'is--inactive' : 'is--active'
            }`}
            timeout={600}
            in={startSlideActive === false}
            enter={startSlideActive === false}
            key={`content-slide`}
            /* appear={startSlideActive === false} */
          >
            <div className="start-wrapper-item start-wrapper-content">
              {children}
            </div>
          </CSSTransition>
        </div>
      ) : (
        <>{children}</>
      )}
    </>
  )
}

export default StartSlideWrapper
